import clsx from 'clsx'

import './index.scss'

type TableWrapperProps = {
  className?: string
  children: React.ReactNode
}
export function TableWrapper({ children, className }: TableWrapperProps) {
  return (
    <section className={clsx('table-wrapper', className)}>{children}</section>
  )
}
